@if (isAuthenticated) {
<app-sidenav />
} @else {
<router-outlet />
}
